$(document).on('ready', function () {
    $('.offer-details__sticky').each(function () {
        $('.layout').css({ overflow: 'visible' });
        $(this).Stickyfill();
    });

    $('.offer-details__show-photos').on('click', '.link', function (e) {
        e.preventDefault();

        var $this = $(this);
        $this.closest('.offer-details__show-photos').addClass('offer-details__show-photos_toggled');
    });
});
